"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RetailerMapsService = void 0;
const api_1 = require("./api");
const PATH = '/retailer/api';
class RetailerMapsService {
    static async getStoreLocations(query) {
        try {
            return await api_1.API.get({
                url: `${PATH}/stores/location`,
                query
            });
        }
        catch (e) {
            throw e;
        }
    }
    static async fetchRetailers(latitude, longitude, latitudeDelta, longitudeDelta) {
        try {
            return await api_1.API.get({
                url: `${PATH}/stores/location?latitude=${latitude}&longitude=${longitude}&latitudeDelta=${latitudeDelta}&longitudeDelta=${longitudeDelta}`
            });
        }
        catch (e) {
            throw e;
        }
    }
}
exports.RetailerMapsService = RetailerMapsService;
//# sourceMappingURL=retailer-maps-service.js.map